import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-enrollment-confirm',
  templateUrl: './enrollment-confirm.component.html'
})
export class EnrollmentConfirmComponent implements OnInit {
  private router: Router;
  private dialog: MatDialog;
  previousModuleName: string;
  currentModuleName: string;
  goingToPlanner: boolean;
  cookieService: CookieService;

  constructor(public dialogRef: MatDialogRef<EnrollmentConfirmComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.router = this.data.router;
    this.previousModuleName = this.data.backName;
    this.currentModuleName = this.data.name;
    this.dialog = this.data.dialog;
    this.cookieService = this.data.cookieService;
    this.goingToPlanner = this.previousModuleName === 'Your Payment Plan';
  }

  stay(): void {
    this.dialog.closeAll();
  }

  continue(): void {
    if (this.data.currentState) {
      if (this.data.currentState.currentUrl === '/payment') {
        if (this.data.lifeGoalType) {
          if (this.data.lifeGoalType === 'retirement') {
            this.cookieService.set('planner_path', JSON.stringify({ path: 'advice-summary' }), 0, '/', window.location.hostname, true, 'Strict');
            window.location.href = this.data.basePath + 'advice-summary';
          } else if (this.data.lifeGoalType && this.data.lifeGoalType === 'educationSales' &&
            this.data.plannerType && this.data.plannerType === 'StraightShooter') {
            window.location.href = this.data.basePath + 'quote-summary';
          } else if (this.data.lifeGoalType && this.data.lifeGoalType === 'specialEvents' &&
            this.data.plannerType && this.data.plannerType === 'StraightShooter') {
            window.location.href = this.data.basePath + 'quote-summary';
          } else {
            window.location.href = this.data.basePath + 'quote-summary';
          }
        } else {
          window.location.href = '/mmih-cdi-portfolio-client/portfolio/';
        }
      } else {
        this.router.navigateByUrl(this.data.currentState.backUrl);
      }
    } else {
      window.location.href = '/mmih-cdi-portfolio-client/portfolio/';
    }

    this.dialogRef.close();
  }
}
